import {Grid, useTheme} from "@mui/material";
import DealMenu from "../components/DealMenu";
import {Item} from "../../../domains/common/components/Item";
import RealtyFormContainer from "../components/Realty";
import {RolesEnums} from "../../../enums";
import {FilesListContainer} from "../components/FilesContainer";
import {XmlList} from "../components/XmlList";
import React from "react";
import {
  agreementTypesSelect, exceptionsTitle
} from "../../../dictionaries";
import FormSelect from "../../../domains/common/components/FormSelect";
import {Title5} from "../../../domains/common/components/Typography";
import {Responsible} from "../components/Responsible";
import {DKPAddParamsContainer} from "./DealDKPContainer";
import DealCommentContainer from "../components/Comment";
import {saveDealParams} from "../deal";
import {dealData} from "../deal";
import {ParticipantsComponent} from "../components/Participants";
import { ChildStatmentContainer } from "../components/ChildStatement";
/**
 * Тип сделки Регистрация соглашения об уступке
 * @param dealData
 * @param id
 * @returns {Element}
 * @constructor
 */
export function DealAssignmentAgreement() {
  const theme = useTheme();

  return (
    <Grid container spacing={1} sx={{mt: 0.2}}>
      <Grid item xs={12}>
        <DealMenu dealId={dealData.dealId}></DealMenu>
      </Grid>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <RealtyFormContainer values={dealData.realty}/>
        </Item>
      </Grid>


      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <ParticipantsComponent role={RolesEnums.OLD_OWNER}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <FilesListContainer/>
                </Item>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <XmlList value={dealData.dealXmlStatementsList}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <Responsible value={dealData.user}/>
            </Item>
          </Grid>
        </Grid>
      </Grid>


      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <ParticipantsComponent role={RolesEnums.NEW_OWNER}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <ParticipantsComponent role={RolesEnums.REPRESENTATIVE}/>
                </Item>
              </Grid>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <ParticipantsComponent role={RolesEnums.EXT_SIGNER}/>
                </Item>
              </Grid>
              <Grid item xs={12}>
                <ChildStatmentContainer/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <DealCommentContainer />
            </Item>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export function AssignmentAgreementParamsContainer({onChange}) {
  const handleStatmentTypeChange = (e) => {
    onChange ? onChange({agreementType: e.target.value}) : void 0
  }

  const saveAddParams = async (value) => {
    const result = await saveDealParams(value);

    if (!result.ok) {
      openNotify({
        msg: exceptionsTitle[result.message] || result.message || "При изменении параметров возникла ошибка",
        duration: 5000,
        errors: result.errors,
        type: 'error',
        positionH: 'right',
      })
    }
  }

  return (
    <Grid container>
      <Grid item sx={{width: 250}}>
        <Grid container>
          <Grid item xs={12}>
            <Title5 title="Тип договора"/>
          </Grid>
          <Grid item xs={12}>
            <FormSelect name="agreementType"
                        data={agreementTypesSelect} minWidth={250}
                        maxWidth={450} value={dealData?.deal.agreementType}
                        onChange={handleStatmentTypeChange}/>
          </Grid>
        </Grid>
      </Grid>
      <Grid item sx={{width: 250}}>
        <Grid container>
          <Grid item xs={12}>
            <DKPAddParamsContainer dealData={dealData} onChange={saveAddParams}/>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}